import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.roles-help', {
        url: '/roles-help',
        component: 'companyRolesHelp',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/roles-help/roles-help.state.js